(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["colored-blocks"] && !window.DesignMode) return;
  try {
    

window.addEventListener('load', e =>
{
  setupSlider();
});

var slides;
let activeSlideNo = 0;
let noSlides = 0;

function setupSlider()
{
	slides = document.getElementsByClassName('colored-block-slide');
	noSlides = slides.length;

	if (noSlides == 0)
	{
		return;
	}
	

	// show active slide
	slides[activeSlideNo].style.display = 'block';


	// set up click handlers
	document.querySelector('.colored-block-slide-arrow.left').addEventListener('click', event => {

	  // left slider clicked
	  clickSlider('left');

    });

	document.querySelector('.colored-block-slide-arrow.right').addEventListener('click', event => {

	  // right slider clicked
	  clickSlider('right');

    });
}

function clickSlider(direction)
{
	var oldActiveSlideNo = activeSlideNo;
	

	if (direction == 'left')
	{
		activeSlideNo = activeSlideNo - 1;
		if (activeSlideNo == -1)
		{
			activeSlideNo = noSlides - 1;
		}
	}
	else
	{
		activeSlideNo = activeSlideNo + 1;
		if (activeSlideNo == noSlides)
		{
			activeSlideNo = 0;
		}
	}

	slides[oldActiveSlideNo].style.display = 'none';
	slides[activeSlideNo].style.display = 'block';
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    

window.addEventListener('load', e =>
{
    filters = document.getElementsByClassName('collection-sidebar__heading');
	for (let filter of filters)
	{
		filter.click();
	}
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-personality"] && !window.DesignMode) return;
  try {
    

window.addEventListener('load', e =>
{
  setupActiveLinks();
});

function setupActiveLinks()
{
	var currentLink = window.location.href;

	personalityLinks = document.getElementsByClassName('personality-link');

	for (let link of personalityLinks)
	{
        if (link.href == currentLink)
		{
			link.className += " active";
		}
    }
}



  } catch(e) { console.error(e); }
})();

})();
